import { api } from "@/lib/api";

/** Convert a base64url VAPID key to a Uint8Array (required by PushManager). */
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export async function getPushSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

/** Subscribe the browser to Web Push and register the subscription on the backend. */
export async function subscribeToPush() {
  if (!isPushSupported()) throw new Error("Push non supporté par ce navigateur");

  // Ask for permission if needed
  if (Notification.permission !== "granted") {
    const perm = await Notification.requestPermission();
    if (perm !== "granted") throw new Error("Notifications refusées");
  }

  // Fetch the VAPID public key from the backend (fallback to env var)
  let vapidKey = process.env.REACT_APP_VAPID_PUBLIC_KEY || "";
  if (!vapidKey) {
    const { data } = await api.get("/push/vapid-public-key");
    vapidKey = data?.key || "";
  }
  if (!vapidKey) throw new Error("Clé VAPID indisponible");

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey),
    });
  }

  // Persist on the backend (upsert by endpoint)
  await api.post("/push/subscribe", {
    subscription: sub.toJSON(),
    user_agent: navigator.userAgent,
  });
  return sub;
}

export async function unsubscribeFromPush() {
  const sub = await getPushSubscription();
  if (!sub) return;
  try {
    await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
  } catch (_) {}
  try { await sub.unsubscribe(); } catch (_) {}
}
